<script lang="ts" setup>
defineOptions({
  name: 'OpenBreadcrumb',
});

const {
  items = [],
} = defineProps<{
  items?: string[];
}>();
</script>

<template>
  <ABreadcrumb class="open-breadcrumb">
    <ABreadcrumbItem>
      <IconApps />
    </ABreadcrumbItem>
    <ABreadcrumbItem v-for="(item, index) in items" :key="`${item}-${index}`">
      {{ item }}
    </ABreadcrumbItem>
  </ABreadcrumb>
</template>

<style lang="scss" scoped>
.open-breadcrumb {
  :deep(.arco-breadcrumb-item) {
    color: rgb(var(--gray-6));

    &:last-child {
      color: rgb(var(--gray-8));
    }
  }
}
</style>
